// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"6efe4acc","43":"0bf79f44","277":"20fa57db","304":"f1d64cd0","359":"a03f0c8f","379":"be78a357","391":"4fa94d53","569":"f4e6eae7","923":"f1dd0d37"}[chunkId] + ".chunk.js";
};